import { useBooking } from "@/context/BookingContext";

export default function StickyMobileCTA() {
  const { openBooking } = useBooking();
  return (
    <div
      data-testid="sticky-mobile-cta"
      className="lg:hidden fixed bottom-0 left-0 right-0 z-40 p-3 bg-[#FAF8F5]/95 backdrop-blur-xl border-t border-[#1C1917]/10"
    >
      <button
        data-testid="sticky-book-now"
        onClick={() => openBooking()}
        className="w-full bg-[#C5B382] active:bg-[#B8A572] text-[#1C1917] text-sm font-semibold tracking-[0.2em] uppercase py-3.5 rounded-full"
      >
        Book Now
      </button>
    </div>
  );
}
